/**
 * Idempotent custom element registration helper.
 *
 * This function prevent errors when
 * attempting to re-register an already defined custom element. This is particularly
 * useful during development with HMR (Hot Module Replacement) where modules can be
 * re-executed, causing customElements.define() to be called multiple times for the
 * same element name.
 *
 * @param {string} name - The name of the custom element (must contain a hyphen)
 * @param {CustomElementConstructor} constructor - The class constructor for the element
 * @param {ElementDefinitionOptions} [options] - Optional configuration object
 *
 * @example
 * import { defineCustomElement } from './utility/define-custom-element';
 *
 * class MyElement extends LitElement {
 *   // ...
 * }
 *
 * defineCustomElement('my-element', MyElement);
 */
export function defineCustomElement(name, constructor, options) {
  // Only define if not already registered
  if (!window.customElements.get(name)) {
    window.customElements.define(name, constructor, options);
  }
}
